import DocumentsPage from "../components/myDocuments/main";

const Documents = () => {
  return <DocumentsPage />;
};

export default Documents;
